<template>
  <div :class="$attrs.class">
    <select 
      v-model="selectedCode"
      class="w-full shadow rounded-md border-2 border-white border-b-[#8CBAFF] pl-3 py-2 text-[#4F4F4F] font-normal text-[16px] font-[Roboto] appearance-none"
    >
      <option v-for="country in countries" :key="country.code" :value="country.code" :title="country.name">
        {{ country.flag }} {{ country.code }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'CountriesPhoneCode',
  props: {
    modelValue: {
      type: String,
      default: '+55'
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      countries: [
        { code: '+55', flag: '🇧🇷', name: 'Brasil' },
        { code: '+1', flag: '🇺🇸', name: 'Estados Unidos' },
        { code: '+44', flag: '🇬🇧', name: 'Reino Unido' },
        { code: '+1', flag: '🇨🇦', name: 'Canadá' },
        { code: '+61', flag: '🇦🇺', name: 'Austrália' },
        { code: '+91', flag: '🇮🇳', name: 'Índia' },
        { code: '+34', flag: '🇪🇸', name: 'Espanha' },
        { code: '+52', flag: '🇲🇽', name: 'México' },
        { code: '+54', flag: '🇦🇷', name: 'Argentina' },
        { code: '+57', flag: '🇨🇴', name: 'Colômbia' },
        { code: '+51', flag: '🇵🇪', name: 'Peru' },
        { code: '+86', flag: '🇨🇳', name: 'China' },
        { code: '+886', flag: '🇹🇼', name: 'Taiwan' },
        { code: '+65', flag: '🇸🇬', name: 'Singapura' },
        { code: '+60', flag: '🇲🇾', name: 'Malásia' },
        { code: '+852', flag: '🇭🇰', name: 'Hong Kong' },
        { code: '+351', flag: '🇵🇹', name: 'Portugal' },
        { code: '+244', flag: '🇦🇴', name: 'Angola' },
        { code: '+258', flag: '🇲🇿', name: 'Moçambique' },
        { code: '+238', flag: '🇨🇻', name: 'Cabo Verde' },
        { code: '+7', flag: '🇷🇺', name: 'Rússia' },
        { code: '+7', flag: '🇰🇿', name: 'Cazaquistão' },
        { code: '+380', flag: '🇺🇦', name: 'Ucrânia' },
        { code: '+375', flag: '🇧🇾', name: 'Bielorrússia' },
        { code: '+998', flag: '🇺🇿', name: 'Uzbequistão' },
        { code: '+81', flag: '🇯🇵', name: 'Japão' },
        { code: '+20', flag: '🇪🇬', name: 'Egito' },
        { code: '+212', flag: '🇲🇦', name: 'Marrocos' },
        { code: '+966', flag: '🇸🇦', name: 'Arábia Saudita' },
        { code: '+213', flag: '🇩🇿', name: 'Argélia' },
        { code: '+977', flag: '🇳🇵', name: 'Nepal' },
        { code: '+679', flag: '🇫🇯', name: 'Fiji' }
      ]
    }
  },
  computed: {
    selectedCode: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    }
  }
};
</script>

<style scoped>
select {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%232E6DD1'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 16px;
}
</style>